import $ from 'jquery';
import 'slick-carousel';

export default class Carousel {
  constructor(el) {
    this.el = el;

    const items = el.querySelectorAll('[data-trigger]');
    const carousel = el.querySelector('[data-carousel]');
    const player = el.querySelector('[data-player] iframe');

    if (items && !!items.length) {
      items.forEach((item) => {
        item.addEventListener('click', this.handleClicks.bind(event, player));
      });
    }

    $(function () {
      $(carousel).slick({
        infinite: false,
        slidesToShow: 4,
        dots: false,
        adaptiveHeight: false,
        draggable: true,
        nextArrow:
          '<button class="slick-arrow slick-next"><svg class="w-12 h-12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--chevron-right"></use></svg></button>',
        prevArrow:
          '<button class="slick-arrow slick-prev"><svg class="w-12 h-12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--chevron-left"></use></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2,
              centerMode: true,
              centerPadding: '40px',
              infinite: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '40px',
              infinite: true,
            },
          },
        ],
      });
    });
  }

  handleClicks(player, event) {
    const trigger = event.target;
    const type = trigger.dataset.videoType.replace(/ /g, '');
    const videoId = trigger.dataset.videoId.replace(/ /g, '');

    event.preventDefault();

    player.src =
      type == 'vimeo'
        ? `https://player.vimeo.com/video/${videoId}?autoplay=1`
        : type == 'youtube'
        ? `https://www.youtube.com/embed/${videoId}?autoplay=1`
        : type == 'kaltura'
        ? `https://cdnapisec.kaltura.com/p/5135432/embedPlaykitJs/uiconf_id/51949032?iframeembed=true&entry_id=${videoId}&config[provider]={"widgetId":1_nlwprjtx}&config[playback]={"startTime":0}`
        : null;
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ThumbnailCarousel.js